export default __webpack_public_path__ + "static/media/super_sert_step_1.fa8a3811.gif";